import { Box, Button, Tab, Tabs } from '@mui/material';
import useTopPanel from 'hooks/useTopPanel';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TabOne from './tabs/TabOne';
import TabTwo from './tabs/TabTwo';
import TabThree from './tabs/TabThree';

const Payment = () => {
  const { setComponent } = useTopPanel();
  const { t, i18n } = useTranslation();
  const axiosPrivate = useAxiosPrivate();
  const [tabIndex, setTabIndex] = useState(1);
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    setComponent(
      <div className='component-title'>{t('boss.payment.title')}</div>
    );
  }, [i18n.language]);

  const handleChangeTab = (event, newValue) => {
    setTabIndex(newValue);
  };

  // Obyektlar kesimida Excel — har obyekt sheet, oy bo'yicha Kutilgan + Tushum
  const handleExport = async () => {
    try {
      setExporting(true);
      // Filtersiz — doim to'liq: Muddati o'tgan / Joriy oy / keyingi oylar
      const res = await axiosPrivate.get('/analytic/payment/objects-excel', {
        responseType: 'blob',
      });
      const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `tolovlar_obyektlar_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className='component-wrapper boss-payment-wrapper'>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Tabs value={tabIndex} onChange={handleChangeTab}>
          <Tab label={t('boss.payment.title')} value={1} />
          <Tab label={t('boss.payment.paymentDate')} value={2} />
          <Tab label={t('contract.view.paymentTable')} value={3} />
        </Tabs>

        <Button
          variant='contained'
          color='success'
          size='small'
          disabled={exporting}
          onClick={handleExport}
          startIcon={<i className='bi bi-file-earmark-excel' />}
          sx={{ mr: 1, whiteSpace: 'nowrap' }}
        >
          {exporting ? '...' : 'Excel (obyektlar)'}
        </Button>
      </Box>

      {tabIndex == 1 && <TabOne />}

      {tabIndex == 2 && <TabTwo />}

      {tabIndex == 3 && <TabThree />}
    </div>
  );
};
export default memo(Payment);
